import { BoxContainer } from '@/components';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { JSX } from 'react';
import { ProductsInformationInner } from './ProductsInformationInner/ProductsInformationInner';
import styles from './styles.module.scss';

export type ProductsInformationProps =
  SliceComponentProps<Content.ProductsInformationSlice>;

const ProductsInformation = ({
  slice,
}: ProductsInformationProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <BoxContainer styles={styles.box_container}>
        <ProductsInformationInner data={slice.primary} />
      </BoxContainer>
    </section>
  );
};

export default ProductsInformation;
